import utils = egr.wcf.utils;

export abstract class Converter {
    public static b64EncodeUnicode(value: string): string {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return btoa(encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, (match: string, p1: string): string => {
            return String.fromCharCode('0x' + p1 as any);
        }));
    }

    public static b64DecodeUnicode(value: string): string {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(value).split('').map((c: string): string => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    public static dataUrlToBase64String(data: string): string {
        const term: string = ';base64,';
        const termLength: number = term.length;

        const index: number = data.indexOf(term);
        if (index === -1) {
            throw new Error('unsupported data url');
        }

        return data.substr(index + termLength);
    }

    public static Uint8ArrayToString(data: Uint8Array): string {
        let value: string = '';

        // Note: a loop is used instead of `String.fromCharCode.apply` to
        // avoid `Maximum call stack size` exceptions
        for (let i: number = 0, l: number = data.length; i < l; i++) {
            value += String.fromCharCode(data[i]);
        }

        return value;
    }

    public static base64ToUint8Array(data: string): Uint8Array | null {
        if (utils.string.isNullOrEmpty(data)) {
            return null;
        }

        const byteStr: string = atob(data);
        const len: number = byteStr.length;
        const bytes: Uint8Array = new Uint8Array(len);
        for (let i: number = 0; i < len; i++) {
            bytes[i] = byteStr.charCodeAt(i);
        }

        return bytes;
    }

    public static base64ToBlob(data: string, contentType: string = '', sliceSize: number = 512): Blob {
        const byteCharacters: string = atob(data);
        const byteArrays: Array<any> = [];

        for (let offset: number = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice: string = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers: Array<number> = new Array(slice.length);
            for (let i: number = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray: Uint8Array = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: contentType});
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/Converter.ts